import logoSpinner from '../../../assets/logo.svg' // ** Logo
//import logoSpinner from '@src/assets/images/logo/logo.png'
import './styles.scss'
const SpinnerComponent = props => {
  const { logo } = props
  return (
    <div className={`fallback-spinner  vh-100`}>
      <div className="spinnerWrapper">
        {logo && <img className="fallback-logo" src={logoSpinner} alt="logo" />}
        <div className="loading">
          <div className="effect-1 effects"></div>
          <div className="effect-2 effects"></div>
          <div className="effect-3 effects"></div>
        </div>
      </div>
    </div>
  )
}

export default SpinnerComponent
